export function errorMessages(value) {
  if (Array.isArray(value)) return value.reduce((all, item) => all.concat(errorMessages(item)), []);
  return typeof value === "string" && value.trim() ? [value] : [];
}

export function normalizeOrderErrors(errors, messages) {
  const result = Array.isArray(errors) ? { _form: errorMessages(errors) } : { ...(errors || {}) };
  [ ["mobile_disp", "customer_mobile"], ["phone_disp", "customer_phone"] ].forEach(([alias, name]) => {
    if (result[alias]) {
      result[name] = errorMessages(result[name]).concat(errorMessages(result[alias]));
      delete result[alias];
    }
  });
  // Messages repeated in the field errors should disappear with that field.
  const existing = Object.values(result).reduce((all, value) => all.concat(errorMessages(value)), []);
  const general = errorMessages(messages).filter((message) => !existing.includes(message));
  if (general.length) result._form = errorMessages(result._form).concat(general);
  return result;
}
